// Module
var code = `<template>
  <mdc-dialog view-model.ref="dialog">
    <mdc-dialog-title>Assign User</mdc-dialog-title>
    <mdc-dialog-content>
      <div mdc-menu-surface-anchor style="width: 100%; min-width: 400px; min-height: 200px;">
        <mdc-text-field ref="input" label="Select User" style="width: 100%;"></mdc-text-field>
        <mdc-lookup options.bind="getOptions" value.bind="model.selectedId" input.bind="input" display-field="name" value-field="id" debounce="300" preload-options hoist-to-body natural-width>
            <template replace-part="option">
                <mdc-list-item-primary-text>\${option.name}</mdc-list-item-primary-text>
                <mdc-list-item-secondary-text>\${option.email}</mdc-list-item-secondary-text>
            </template>
        </mdc-lookup>
      </div>
      <p mdc-body2 style="margin-top: 16px;">Users assigned here will get access to all companies in this corporation.</p>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button click.trigger="dialog.close('cancel')">Cancel</button>
      <button mdc-button click.trigger="dialog.close('ok')" disabled.bind="!model.selectedId">Assign</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;